module.exports = __webpack_public_path__ + "img/404.99468ed9.svg";